import { render } from "./DashboardLayout.vue?vue&type=template&id=2368690a"
const script = {}

import exportComponent from "E:\\Proyects\\Front end Clinica cruz jiminian\\cruzsgss-develop (1)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__